import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'antd';
import { MARKETPLACE_CONSTANTS } from '../../constants/MarketplaceConstants';
import '../../styles/components/MarketPlace/ScreenNavigation.scss';
import useMoengage from '../../hooks/useMoengage';
import moment from 'moment';
import { useMitraStore } from '../../contexts/MitraContext';

let { NAVIGATION_ITEMS } = MARKETPLACE_CONSTANTS;

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}
const NavigationButton = ({ data, rightBorder }) => {
  const query = useQuery();
  const navbar = query.get('navbar');
  const { selectedMitraDetails } = useMitraStore();
  const [currentNav, setCurrentNav] = useState(
    navbar && navbar !== '' ? navbar : NAVIGATION_ITEMS[0]?.key
  );
  const [, trackEvent] = useMoengage();

  const history = useHistory();
  const handleNavigation = item => {
    const preferredLocation = localStorage.getItem('preferredLocation');
    setCurrentNav(item?.key);

    if (item.key === 'mitraVideos') {
      trackEvent('jse_clicked_mitra_videos', 
      { 
        userId: localStorage.getItem('userId'), 
        userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
        timeStamp: moment().format('MM/DD/YYYY HH:mm:ss') 
      });
    }

    history.replace(`${item?.URL}?city=${preferredLocation}&navbar=${item?.key}`);
  };
  return (
    <div>
      <Button
        style={{
          width: '100%',
          border: 'none',
          fontWeight: 'bold',
        }}
        onClick={data?.navigationTo === 'local' ? () => handleNavigation(data) : ''}
      >
        {data?.icon(currentNav === data?.key)}
        <span
          style={{
            display: 'block',
            color: currentNav === data?.key ? '#111111' : '#555555',
            background: '#FFF',
            fontSize: '0.86em',
          }}
        >
          {data?.label}
        </span>
      </Button>
      {/* {rightBorder && (
        <div
          style={{
            borderRight: '0.1em solid #D86235',
            height: '2em',
            marginTop: '-0.8em',
            position: 'relative',
            top: '-0.6em',
          }}
          onClick={() => handleNavigation(data)}
        />
      )} */}
    </div>
  );
};

const ScreenNavigation = () => {
  const [, trackEvent] = useMoengage();
  const location = useLocation();
  console.log(location);

  useEffect(() => {
    if (localStorage.getItem('appVersion') && parseInt(localStorage.getItem('appVersion')) > 66) {
      // do nothing      
    } else {
      NAVIGATION_ITEMS = NAVIGATION_ITEMS.filter(item => item.key !== 'mitraReferrals');
    }
  }, [])
  

  return (
    <div className="navigation-main-container">
      {NAVIGATION_ITEMS.map((item, index) => (
        <div className="single-navigation" key={item?.key}>
          {item?.navigationTo === 'local' ? (
            <NavigationButton data={item} rightBorder={index !== NAVIGATION_ITEMS.length - 1} />
          ) : (
            <a
              href={`${item?.URL}${location.search}&userId=${localStorage.getItem(
                'userId'
              )}&entryVia=${location.pathname.substring(1)}`}
            >
              <NavigationButton data={item} rightBorder={index !== NAVIGATION_ITEMS.length - 1} />{' '}
            </a>
          )}
        </div>
      ))}
    </div>
  );
};

export default ScreenNavigation;
